import React from 'react';
import EpiContext from '@episerver/spa-core/Spa';
import {isMobile} from 'react-device-detect';
import Config from 'app/Config';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import Image from 'app/Components/Shared/Image/image';

const SendSmsEntityPaymentSuccess = ({phoneNumber}) => {
  const handleGoToPersonalArea = () => {
    EpiContext.navigateTo(Config.lobbyUrl);
  };

  return (
    <div className='debtpayment-step send-sms-entity-payment-success-step'>
      <div className='send-sms-entity-payment-success-content'>
        <div className='success-icon'>
          <Image src={require('../images/success.svg')} alt='payment icon' />
        </div>

        <div className='l-title'>
          הבקשה להגדרת אמצעי תשלום
          <br /> חדש נשלחה בהצלחה!
        </div>

        {phoneNumber && (
          <div className={`m-title ${isMobile ? 's-title-small' : 'm-title'}`}>
            הבקשה נשלחה למספר {phoneNumber}
            <br /> לשם השלמת התהליך, עם סיומו נשלח
            <br /> אליך עדכון ב-SMS.
          </div>
        )}
      </div>

      <div className='continue-button'>
        <BtnSubmit text='לאיזור האישי' onclick={handleGoToPersonalArea} />
      </div>
    </div>
  );
};

export default SendSmsEntityPaymentSuccess;
